type RawMenuItem = {
  id: number
  title: string
  slug: string
  url: string
  parentSlug?: string
  sort: number
  showMenu: boolean
}

type FormattedMenuItem = {
  titleKey: string
  href: string
  url: string
  showMenu: boolean
  children?: FormattedMenuItem[]
}

export function buildMenuTree(items: RawMenuItem[]): FormattedMenuItem[] {
  const map = new Map<string, FormattedMenuItem & { _slug: string; _parentSlug?: string }>()
  const tree: FormattedMenuItem[] = []

  // Step 1: Đưa vào map tạm thời
  for (const item of items) {
    map.set(item.slug, {
      _slug: item.slug,
      _parentSlug: item.parentSlug,
      titleKey: item.title,
      href: item.url,
      url: item.url,
      showMenu: item.showMenu,
      children: [],
    })
  }

  // Step 2: Gắn con vào cha nếu có
  for (const node of map.values()) {
    if (node._parentSlug && map.has(node._parentSlug)) {
      map.get(node._parentSlug)!.children!.push(node)
    } else {
      tree.push(node)
    }
  }

  // Step 3: Dọn dữ liệu tạm (_slug, _parentSlug)
  const clean = (
    items: (FormattedMenuItem & { _slug?: string; _parentSlug?: string })[]
  ): FormattedMenuItem[] =>
    items.map(({ _slug, _parentSlug, children, ...rest }) => ({
      ...rest,
      ...(children && children.length ? { children: clean(children) } : {}),
    }))

  return clean(tree)
}
